import React from 'react';

const CareXLogo: React.FC<{ style?: React.CSSProperties, className?: string }> = ({ style, className }) => (
  <img
    src={process.env.PUBLIC_URL + '/assets/carex-logo.png'}
    alt="CareX Nursing Home Software Logo"
    style={{ height: '80px', width: 'auto', maxWidth: '200px', ...style }}
    className={className}
  />
);

export default CareXLogo;
